import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import 'date-fns';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import red from '@material-ui/core/colors/red';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie'
import withMobileDialog from '@material-ui/core/withMobileDialog';
import request from 'superagent'
import * as Constants from '../constants'

const styles = theme => ({
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  icon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});

class ChangeAccountDataDialog extends React.Component {
  state = {
    loading: false,
    initializing: false,
    snackbar_open: false,
    extended_user_data: {
      polite_form: "",
      first_name: "",
      last_name: "",
      email: "",
      tel: "",
      zip_code: "",
      city: "",
      address: "",
      response_mail: "",
    },
    polite_form: "",
    bill: 0,
    first_name: null,
    last_name: null,
    email: null,
    tel: null,
    zip_code: null,
    city: null,
    address: null,
    correction_check: false,
  }

  loadUserData = () => {
    this.setState({ initializing: true });
    let currentComponent = this;
    request.post(Constants.BACKEND_URL)
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('accept', 'json')
      .send({ command: "getaccountdata", parent_id: this.props.parentId })
      .end((err, res) => {
        var result = res.text.trim();
        if (result !== "") {
          var obj = JSON.parse(result)[0];
          currentComponent.setState({ extended_user_data: obj, polite_form: obj.polite_form === "1" ? 1 : 2, bill: obj.response_mail === "0" ? 1 : 0, initializing: false, loading: false });
        } else {
          currentComponent.setState({ snackbar_open: true, loading: false });
        }
      });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  clickCorrectionCheck = (event) => {
    this.setState({ correction_check: !this.state.correction_check });
  }

  handleClickShowPassword = (event) => {
    this.setState({ showPassword: !this.state.showPassword });
  }

  billPerEmail = () => {
    this.setState({ bill: 0 });
  }

  billPerPost = () => {
    this.setState({ bill: 1 });
  }

  onReset = () => {
    this.setState({ polite_form: "", first_name: null, last_name: null, email: null, tel: null, zip_code: null, city: null, address: null, correction_check: false, loading: false, initializing: false });
  }

  changeData = () => {
    this.setState({ loading: true });
    //Daten übertragen
    if (this.state.polite_form === null) this.state.polite_form = this.state.extended_user_data.polite_form;
    if (this.state.first_name === null) this.state.first_name = this.state.extended_user_data.first_name;
    if (this.state.last_name === null) this.state.last_name = this.state.extended_user_data.last_name;
    if (this.state.email === null) this.state.email = this.state.extended_user_data.email;
    if (this.state.tel === null) this.state.tel = this.state.extended_user_data.tel;
    if (this.state.zip_code === null) this.state.zip_code = this.state.extended_user_data.zip_code;
    if (this.state.city === null) this.state.city = this.state.extended_user_data.city;
    if (this.state.address === null) this.state.address = this.state.extended_user_data.address;

    if (this.state.first_name !== "" && this.state.last_name !== "" && this.state.email !== "" && this.state.tel !== "" && this.state.correction_check) {
      //Alles ist ausgefüllt
      if (this.isValidEmail(this.state.email)) {
        //Die E-Mail Adresse ist gültig
        let currentComponent = this;
        request.post(Constants.BACKEND_URL)
          .set('Content-Type', 'application/x-www-form-urlencoded')
          .set('accept', 'json')
          .send({ command: "changeaccountdata", parent_id: this.props.parentId, polite_form: this.state.polite_form, first_name: this.state.first_name, last_name: this.state.last_name, email: this.state.email, tel: this.state.tel, zip: this.state.zip_code, city: this.state.city, address: this.state.address, bill_per_email: (this.state.bill === 0 ? "1" : "0") })
          .end((err, res) => {
            var result = res.text.trim();
            if (result === "1") {
              if (currentComponent.props.cookies.get("staySignedIn") !== null) currentComponent.props.cookies.set('staySignedIn', { email: this.state.email, pw: currentComponent.props.cookies.get("staySignedIn").pw });
              //erfolgreich hinzugefügt
              currentComponent.setState({ extended_user_data: { polite_form: "", first_name: "", last_name: "", email: "", tel: "", zip_code: "", city: "", address: "", }, correction_check: false, error_first_name: false, error_last_name: false, error_email: false, error_tel: false, error_zip_code: false, error_city: false, error_address: false, error_correction_check: false });
              currentComponent.props.onClose();
              currentComponent.onReset();
            } else {
              currentComponent.setState({ snackbar_open: true, loading: false });
            }
          });
      } else {
        //Die E-Mail Adresse ist nicht gültig
        this.setState({ error_email: true, loading: false });
      }
    } else {
      this.setState({ error_first_name: this.state.first_name === "", error_last_name: this.state.last_name === "", error_email: this.state.email === "", error_tel: this.state.tel === "", error_zip_code: (this.state.bill === 1 && this.state.zip_code === ""), error_city: (this.state.bill === 1 && this.state.city === ""), error_address: (this.state.bill === 1 && this.state.address === ""), error_correction_check: !this.state.correction_check, loading: false });
    }
  }

  onClose = () => {
    this.onReset();
    this.props.onClose();
  }

  onEnterPressed = (ev) => {
    if (ev.key === 'Enter') {
      this.changeData();
      ev.preventDefault();
    }
  }

  handleSnackbarClose = () => {
    if (this.state.initializing) {
      this.setState({ snackbar_open: false, initializing: false });
      this.props.onClose();
    } else {
      this.setState({ snackbar_open: false });
    }
  }

  isValidEmail(email) {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  render() {
    const { classes, fullScreen } = this.props;

    if (this.props.open && this.state.extended_user_data.polite_form === "" && !this.state.initializing) this.loadUserData();

    return (
      <Dialog fullScreen={fullScreen} open={this.props.open}>
        <DialogTitle>{"Accountdaten ändern"}</DialogTitle>
        <DialogContent style={{ paddingLeft: 20, paddingRight: 20 }}>
          {/* Anrede */}
          <FormControl style={{ minWidth: 100, marginRight: 10, marginTop: 10 }} disabled={this.state.initializing} error={this.state.error_polite_form}>
            <InputLabel htmlFor="pf" shrink={this.state.extended_user_data.polite_form !== "" || this.state.polite_form !== ""} required>Anrede</InputLabel>
            <Select value={this.state.polite_form === "" ? parseInt(this.state.extended_user_data.polite_form) : parseInt(this.state.polite_form)} onChange={this.handleChange('polite_form')} inputProps={{ id: 'pf' }}>
              <MenuItem value={1} selected>Frau</MenuItem>
              <MenuItem value={2}>Herr</MenuItem>
            </Select>
          </FormControl>
          {/* Vorname */}
          <TextField label="Vorname" value={this.state.first_name === null ? this.state.extended_user_data.first_name : this.state.first_name} disabled={this.state.initializing} onChange={this.handleChange('first_name')} onKeyPress={this.onEnterPressed} style={{ width: 220, marginRight: 10, marginTop: 10 }} error={this.state.error_first_name} required />
          {/* Nachname */}
          <TextField label="Nachname" value={this.state.last_name === null ? this.state.extended_user_data.last_name : this.state.last_name} disabled={this.state.initializing} onChange={this.handleChange('last_name')} onKeyPress={this.onEnterPressed} style={{ width: 220, marginTop: 10 }} error={this.state.error_last_name} required />
          {/* E-Mail */}
          <TextField label="E-Mail-Adresse" value={this.state.email === null ? this.state.extended_user_data.email : this.state.email} disabled={this.state.initializing} onKeyPress={this.onEnterPressed} onChange={this.handleChange('email')} style={{ width: "49%", marginTop: 10, marginRight: "2%" }} type="email" error={this.state.error_email} required />
          {/* Tel */}
          <TextField label="Telefonnummer" value={this.state.tel === null ? this.state.extended_user_data.tel : this.state.tel} disabled={this.state.initializing} onKeyPress={this.onEnterPressed} onChange={this.handleChange('tel')} style={{ width: "49%", marginTop: 10 }} type="tel" error={this.state.error_tel} required />
          {/* PLZ */}
          <TextField label="PLZ" value={this.state.zip_code === null ? this.state.extended_user_data.zip_code : this.state.zip_code} onChange={this.handleChange('zip_code')} onKeyPress={this.onEnterPressed} style={{ width: 100, marginRight: 10, marginTop: 10 }} disabled={this.state.initializing} type="number" error={this.state.error_zip_code} required={this.state.bill === 1} />
          {/* Ort */}
          <TextField label="Ort / Ortsteil" value={this.state.city === null ? this.state.extended_user_data.city : this.state.city} onChange={this.handleChange('city')} onKeyPress={this.onEnterPressed} style={{ width: 170, marginRight: 10, marginTop: 10 }} disabled={this.state.initializing} error={this.state.error_city} required={this.state.bill === 1} />
          {/* Adresse */}
          <TextField label="Adresse" value={this.state.address === null ? this.state.extended_user_data.address : this.state.address} onChange={this.handleChange('address')} onKeyPress={this.onEnterPressed} style={{ width: 270, marginTop: 10 }} disabled={this.state.initializing} error={this.state.error_address} required={this.state.bill === 1} />
          {/* Richtigkeit */}
          <FormControlLabel control={<Checkbox checked={this.state.correction_check} onChange={this.clickCorrectionCheck} />} disabled={this.state.initializing} label={this.state.error_correction_check ? (<font color='red'>Ich habe meine Eingaben auf Richtigkeit geprüft.</font>) : ("Ich habe meine Eingaben auf Richtigkeit geprüft.")} />
        </DialogContent>
        {/* initializing */}
        {this.state.initializing && <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}><CircularProgress color="secondary" /></div>}
        <DialogActions>
          <Button onClick={this.onClose} variant="contained" disabled={this.state.initializing || this.state.loading}>Abbrechen</Button>
          <Button onClick={this.onReset} variant="contained" disabled={this.state.initializing || this.state.loading}>Formular zurücksetzen</Button>
          <Button onClick={this.changeData} variant="contained" disabled={this.state.initializing || this.state.loading} color="primary" autoFocus>
            {"Speichern"}
            {this.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Button>
        </DialogActions>
        {/* Error-Snackbar */}
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={this.state.snackbar_open} autoHideDuration={3000} onClose={this.handleSnackbarClose}>
          <SnackbarContent
            message={
              <span className={classes.message}>
                <ErrorIcon className={classes.icon} />
                Es ist ein Fehler aufgetreten. Versuchen Sie es später erneut.
              </span>
            }
            action={[
              <IconButton color="inherit" key="close" onClick={this.handleSnackbarClose}>
                <CloseIcon style={{ fontSize: 20 }} />
              </IconButton>,
            ]}
            style={{ backgroundColor: red[600] }} />
        </Snackbar>
      </Dialog>
    );
  }
}

ChangeAccountDataDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  fullScreen: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  parentId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withMobileDialog()(withCookies(withStyles(styles, { withTheme: true })(ChangeAccountDataDialog)));
